export default __webpack_public_path__ + "static/media/family.2b98bd6f.svg";